'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var banner = (0, _functional.getElement)('.ck-Banner');
  var button = (0, _functional.getElements)('.ck-Banner_Link-accept');

  button.forEach(function (modalClose) {
    modalClose.addEventListener('click', function () {
      _jsCookie2.default.set('bbcicecream-cookie-information', 'true', {
        expires: 3650
      });

      banner.classList.remove('ck-Banner-active');
    });
  });
}